<template>
  <apexchart type="bar" height="350" :options="chartOptions" :series="series"></apexchart>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'
import {scale} from "@/utils/colors";

export default {
  name: "TopProjectsBySavings",
  components: {
    apexchart: VueApexCharts,
  },
  props: {
    stakeholders: {
      type: Array,
      default: () => ([])
    },
  },
  data: () => ({
    dataColor: scale(1)
  }),
  computed: {
    chartOptions() {
      return {
        chart: {
          export: {
            csv: {
              headerCategory: 'Stakeholders',
            }
          },
        },
        title: {
          text: 'Top Stakeholders By Project Count',
          align: 'center',
          floating: true
        },
        noData: {
          text: 'No Data To Show Yet',
        },
        plotOptions: {
          bar: {
            horizontal: true,
            dataLabels: {
              position: 'bottom' // use 'bottom' for left and 'top' for right align
            },
          }
        },
        colors: this.dataColor,
        dataLabels: {
          formatter: function (val, opt) {
            const {stakeholder} = opt.w.config.series[opt.seriesIndex].data[opt.dataPointIndex]
            return stakeholder ? stakeholder.fullName : ''
          },
          textAnchor: 'start',
          offsetX: 10,
          style: {
            colors: ['black']
          },
        },
        legend: {
          show: true,
          showForSingleSeries: true,
          customLegendItems: ['Stakeholders'],
          markers: {
            fillColors: [this.dataColor, '#775DD0']
          }
        },
        tooltip: {
          x: {
            formatter: (val, opt) => {
              const {stakeholder} = opt.w.config.series[opt.seriesIndex].data[opt.dataPointIndex]
              return stakeholder ? stakeholder.fullName : ''
            }
          },
        },
        yaxis: {
          labels: {
            show: false
          }
        }
      }
    },
    series() {
      return [{
        name: 'Projects',
        data: this.stakeholders.map((stakeholder) => {
          return {
            x: stakeholder.projectCount,
            y: stakeholder.projectCount,
            stakeholder,
          }
        })
      }]
    }
  }
}
</script>

<style scoped>

</style>
